export default __webpack_public_path__ + "static/media/bkg--location-2.73cb1f6e.jpg";